import { Component, Inject, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEnvironment } from '../../services/environment/environment.interface';
import { TypeResponse } from 'gtd-ng-widget';
import { AuthServiceInterface } from '../../services/auth/auth-service.interface';
import { Row } from '../table-facade/data.response';
import { IDataService } from '../../services/data/data-service.interface';

@Component({
  selector: 'gtd-switch-account-widget',
  templateUrl: './switch-account-widget.component.html',
})
export class SwitchAccountWidgetComponent {
  @Input() affiliates: Row[];
  public searchName: string = '';
  public userID: number;

  private readonly globalData = this.dataService.getData();

  constructor(
    private http: HttpClient,
    @Inject('IEnvironmentService') private envService: IEnvironment,
    @Inject('AuthServiceInterface') public authService: AuthServiceInterface,
    @Inject('IDataService') private dataService: IDataService
  ) {
    this.authService.getUser().subscribe((user) => (this.userID = user.id));
  }

  login(affiliateId: number) {
    const loginApiUrl = (this.envService.getVar('services.api') as string) + '/widget/data';
    const masterToken = localStorage.getItem('master-affiliate-token');
    const affiliateToken = localStorage.getItem('affiliate-token');
    if (masterToken) {
      localStorage.setItem('affiliate-token', masterToken);
    }
    this.http
      .post<any>(loginApiUrl, {
        widget: 'AffiliateCrm\\Rbac\\AuthAs',
        settings: {
          user_id: affiliateId,
        },
      })
      .subscribe((result: AuthAsResponse) => {
        if (!masterToken) {
          localStorage.setItem('master-affiliate-token', affiliateToken);
        }
        localStorage.setItem('affiliate-token', result.data.user_data.token);
        window.open(`/affiliates/${this.globalData.current_language}/app/dashboard`, '_self');
      });
    if (masterToken) {
      localStorage.setItem('affiliate-token', affiliateToken);
    }
  }
}

export class AuthAsResponse extends TypeResponse {
  data: {
    user_data: {
      token: string;
    };
  };
}
